module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAoAAAAHCAYAAAAxrNxjAAAAAXNSR0IArs4c6QAAACBJREFUGBljTMyrvvX//39VBjyAkZHxNh5pMqUYh4DVAB1eEnAAIUQ3AAAAAElFTkSuQmCC"


//////////////////
// WEBPACK FOOTER
// ./src/assets/image/back-morebtn.png
// module id = 557
// module chunks = 1